import { render, staticRenderFns } from "./PrinciplesGameSetup.vue?vue&type=template&id=13523396&"
import script from "./PrinciplesGameSetup.vue?vue&type=script&lang=js&"
export * from "./PrinciplesGameSetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports